import { render, staticRenderFns } from "./CaldatesInCard.vue?vue&type=template&id=bab1ae96&scoped=true&"
import script from "./CaldatesInCard.vue?vue&type=script&lang=ts&"
export * from "./CaldatesInCard.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bab1ae96",
  null
  
)

export default component.exports